import React from "react";
import { HashRouter, Routes, Route, Link } from "react-router-dom";
import { Element, Link as ScrollLink } from "react-scroll";
import HomePageUi from "./containers/Home";
import "./App.css";
import ProductList from "./containers/Product/index";
import Layout from "./components/Layout/Layout";
import FaqPage from "./containers/Faq/";
import RouteConstants from "./constants/RouteConstants.json";
import ErrorPage404 from "./containers/ErrorPage";

const App = () => {
  return (
    <HashRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path={RouteConstants.HOME} element={<HomePageUi />} />
        </Route>
        <Route element={<Layout />}>
          <Route path={RouteConstants.PRODUCT_PAGE} element={<ProductList />} />
        </Route>
        <Route element={<Layout />}>
          <Route path={RouteConstants.FAQ_PAGE} element={<FaqPage />} />
        </Route>
        <Route path={RouteConstants.ERROR_PAGE} element={<ErrorPage404 />} />
      </Routes>
    </HashRouter>
  );
};

export default App;
